<template>
    <div class="text-sm text-slate-900 flex items-center justify-between py-3 px-6 border-b border-x-0 border-t-0 border-solid border-slate-200 last:border-transparent">
        <div class="md:grid grid-cols-12 gap-2 grow">
            <div class="break-all col-span-4">
                {{ formatPhoneNumber(props.phoneNumber.phone_number) }}
            </div>
            <div class="break-all col-span-2">
                {{ props.phoneNumber.region || '-' }}
            </div>
            <div class="col-span-3">
                {{ props.phoneNumber.locality || '-' }}
            </div>
            <div class="break-all col-span-3">
                {{ props.phoneNumber.postal_code || '-' }}
            </div>
        </div>
        <div class="shrink-0 w-20 text-right">
            <vx-button type="button"
                color="transparent"
                size="xs"
                class="text-sky-600"
                @click.prevent="emit('selected', props.phoneNumber)">
                Add
                <font-awesome-icon widthAuto class="text-xs ml-1"
                    :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus } from "@fortawesome/pro-solid-svg-icons";
import { formatPhoneNumber } from '~/components/filters';

const emit = defineEmits(['selected']);

const props = defineProps({
    phoneNumber: {
        type: Object,
        required: true,
    },
})
</script>
